import { IonImg } from '@ionic/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../../components/actions/Button'
import EnodeInitHeader from '../components/ENodeInitHeader'

interface Props {
	goForward: () => void
}

const SmartChargingAdditionalInfo: React.FC<Props> = ({ goForward }) => {
	const { t } = useTranslation('pages_enodeInit')

	return (
		<>
			<div className='flex flex-row gap-4'>
				<EnodeInitHeader position={3} total={5} text={t('smartChargingAdditionalInfo.otsikko')} />
				<div className='h-[38px] flex items-center mb-2'>
					<span className='text-xl tracking-wide font-semibold dark:text-brand-secondary-100-dark'>
						{t('smartChargingAdditionalInfo.otsikko')}
					</span>
				</div>
			</div>

			<div className='h-[180px] flex justify-center'>
				<IonImg className='h-full' src={'./assets/power_off.png'} />
			</div>

			<div className='dark:text-white flex flex-col gap-4 text-center'>
				<p>{t('smartChargingAdditionalInfo.info1')}</p>
				<p>{t('smartChargingAdditionalInfo.info2')}</p>
			</div>

			<Button onClick={goForward}>{t('jatka', { ns: 'common' })}</Button>
		</>
	)
}

export default SmartChargingAdditionalInfo
